<ng-container *ngFor="let item of radiobuttons">
  <div class="d-flex align-items-center">
    <p-radioButton [name]="item.label" [value]="item.value" [(ngModel)]="value" [inputId]="item.value"></p-radioButton>
    <label [for]="item.value" class="ml-2">{{item.label | allLettersCapital}}</label>
  </div>
</ng-container>
